// const stationMap = require('./stations').map;
// const stationMapGroup = require('./stations').group;

const keyCode = Object.freeze({
    'PAGEUP': 33,
    'PAGEDOWN': 34,
    'END': 35,
    'HOME': 36,
    'LEFT': 37,
    'UP': 38,
    'RIGHT': 39,
    'DOWN': 40,
    'DELETE': 46,
    'ENTER': 13,
    'SPACE': 32,
    'RETURN': 13
});

const direction = Object.freeze({
    37: -1,
    38: -1,
    39: 1,
    40: 1
});

class TabList {
    constructor(domNode, hashChange) {
        this.domNode = domNode;
        this.tabs = [];
        this.panels = [];
        this.hashChange = hashChange || false;
    }

    init() {
        this.tabs = this.domNode.querySelectorAll('[role="tab"]');
        this.panels = this.domNode.querySelectorAll('[role="tabpanel"]');

        for (let i = 0; i < this.tabs.length; ++i) {
            const tab = this.tabs[i];
            tab.addEventListener('click', this.handleClick.bind(this));
            tab.addEventListener('keydown', this.handleKeydown.bind(this));
            tab.addEventListener('keyup', this.handleKeyup.bind(this));
            tab.index = i;
        }

        if (this.hashChange) {
            const iniTab = window.location.hash ? window.location.hash.replace('#', '').toLowerCase() : 'bus';
            this.activateTab(this.domNode.querySelector('#tu-' + iniTab));
        }

        for (let item of document.querySelectorAll('.js-trigger-anchor')) {
            item.addEventListener('click', (e) => {
                const parts = item.href.split('#');
                if(parts.length === 2) {
                    const iniTab = parts[1].toLowerCase();
                    this.activateTab(this.domNode.querySelector('#tu-' + iniTab));
                }
            });
        }
    }

    handleClick(event) {
        const tab = event.currentTarget;
        this.activateTab(tab, false);
    }

    handleKeydown(event) {
        let flag = false;

        switch(event.keyCode) {
            case keyCode.HOME:
            case keyCode.PAGEUP:
                this.focusFirstTab();
                flag = true;
                break;
        
            case keyCode.END:
            case keyCode.PAGEDOWN:
                this.focusLastTab();
                flag = true;
                break;
        
            default:
                break;  
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    handleKeyup(event) {
        let flag = false;

        switch (event.keyCode) {            
            case keyCode.LEFT:
            case keyCode.RIGHT:
                this.determineOrientation(event);
                flag = true;
                break;

            case keyCode.ENTER:
            case keyCode.RETURN:
            case keyCode.SPACE:
                this.activateTab(event.currentTarget);
                flag = true;
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    activateTab(tab, setFocus) {
        setFocus = setFocus || true;

        this.deactivateTabs();

        tab.removeAttribute('tabindex');
        tab.setAttribute('aria-selected', 'true');
        if (this.hashChange) {
            window.location.hash = tab.getAttribute('id').replace('tu-', '');
        }

        const controls = tab.getAttribute('aria-controls');
        document.querySelector('#' + controls).removeAttribute('hidden');

        if (document.querySelector('.tf-tablist')) {
            document.querySelector('.tf-tablist').setAttribute('data-view', 'list');
            const activePanel = document.querySelector('#' + controls);
            const stationsMap = activePanel.querySelector('#stations-map');
            console.log('st',stationsMap);
            if (stationsMap) {
                document.querySelector('.tf-tablist').setAttribute('data-view', 'map');
                if ("createEvent" in document) {
                    const evt = document.createEvent("HTMLEvents");
                    evt.initEvent("displaymap", false, true);
                    stationsMap.dispatchEvent(evt);
                } else {
                    stationsMap.fireEvent("displaymap");
                }
            }
        }

        if (setFocus) {
            tab.focus();
        }
    }

    deactivateTabs() {
        for (let tab of this.tabs) {
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-selected', 'false');
        }

        for(let panel of this.panels) {
            panel.setAttribute('hidden', 'hidden');
        }
    }

    determineOrientation(event) {
        const keyPressed = event.keyCode;
        let proceed = false;

        if (keyPressed === keyCode.LEFT || keyPressed == keyCode.RIGHT) {
            proceed = true;
        }

        if (proceed) {
            this.switchTabOnArrowPress(event);
        }
    }

    switchTabOnArrowPress(event) {
        const keyPressed = event.keyCode;
    
        if (direction[keyPressed]) {
            const target = event.currentTarget;

            if (target.index !== undefined) {
                if (this.tabs[target.index + direction[keyPressed]]) {
                    this.tabs[target.index + direction[keyPressed]].focus();
                } else if (keyPressed === keyCode.LEFT) {
                    this.focusLastTab();
                } else if (keyPressed === keyCode.RIGHT) {
                    this.focusFirstTab();
                }
            }
        }
    }

    focusFirstTab() {
        this.tabs[0].focus();
    }

    focusLastTab() {
        this.tabs[this.tabs.length - 1].focus();
    }
}

if (document.querySelector('.routes-tabs')) {
    const routeTabList = new TabList(document.querySelector('.routes-tabs'), true);
    routeTabList.init();
}

if (document.querySelector('.tf-tabs')) {
    const tfTabList = new TabList(document.querySelector('.tf-tabs'));
    tfTabList.init();
}